import { DataService } from "@xanadu/service";
import { DataCache } from "./data.cache";
import { Client } from "@xanadu/model";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ClientCache extends DataCache<Client> {

    constructor(
        dataService: DataService
    ) {
        super(Client, dataService);
    }
}
